import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStarLines: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="star-lines, features, favorite, award, to the moon, rising"><path d="M9.25 15.75L4.75 20.25M7.25 10.75L2.75 15.25M16.25 15.75L11.75 20.25M15.5 1.75L17.5572 5.16844L21.4441 6.06864L18.8287 9.08156L19.1737 13.0564L15.5 11.5L11.8263 13.0564L12.1713 9.08156L9.5559 6.06864L13.4428 5.16844L15.5 1.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconStarLines;
